// ##############################
// // // detailsPageStyle view styles
// #############################

import {
  blackColor,
  primaryColor,
  dangerColor,
  successColor,
  defaultFont,
  container,
  containerFluid
} from "../../../assets/styles/jss/main" // from "assets/styles/jss/main";
import { StyleRules } from "@material-ui/core/styles/withStyles";

const detailsPageStyle: StyleRules = {
  container,
  containerFluid,
  profilTitle: {
    padding: "15px 0",
    margin: 0,
    fontSize: 28,
    textTransform: "uppercase"
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "85px 0 30px 0",
    height: "100vh",
    position: "relative",
    zIndex: 4,
    overflow: "auto"
  },
  topMargin: {
    marginTop: 30
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  itemGridSix: {
    padding: "0 10px !important",
    maxWidth: "66%",
    flexBasis: "66%",
    "@media (max-width: 600px)": {
      padding: "0 15px !important",
      maxWidth: "100%",
      flexBasis: "100%"
    }
  },
  infoText: {
    fontWeight: 300,
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputLabelIcon: {
    color: "#555",
    verticalAlign: "-5px"
  },
  inputLabelWithoutIcon: {
    paddingTop: "2.63px" // to be pixel perfect align with input label with icon
  },
  inputAlignedWithHelpTextInput: {
    paddingBottom: "31px" // to be pixel perfect align with input label having help text
  },
  inputAdornment: {
    top: "3px",
    position: "relative"
  },
  containerUpload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: "16px"
  },
  containerUploadAlignLeft: {
    display: "flex",
    alignItems: "left",
    flexDirection: "column",
    marginTop: "16px",
  },
  helpTextButton: {
    ...defaultFont,
    fontSize: "14px",
    lineHeight: 1.42857,
    fontWeight: 400,
    margin: "5px 0 0 0"
    //cursor: 'default'
  },
  dangerColor: {
    color: dangerColor
  },
  successColor: {
    color: successColor
  },
  marginRight5: {
    marginRight: "5px"
  },
  marginRight10: {
    marginRight: "10px"
  },
  addCompanyContainer: {
    display: "flex",
    alignItems: "center",
    "@media (max-width: 600px)": {
      display: "initial"
    }
  },
  addCompanyText: {
    //...customFont,
    margin: "0 10px 0 20px",
    "@media (max-width: 600px)": {
      margin: "10px 10px 10px 15px"
    }
  },
  borderButton: {
    border: `1px solid ${primaryColor}`,
    color: primaryColor,
    margin: "0 10px 0 20px",
    "@media (max-width: 600px)": {
      marginLeft: "15px"
    }
  },
  borderPictureLoading: {
    border: "none",
    boxShadow: "none"
  },
  addLogo: {
    marginTop: 25
  },
  noBorderButton: {
    border: "none",
    boxShadow: "none"
  },
  seeExampleButton: {
    fontSize: 14,
    margin: 0,
    padding: 0,
    boxShadow: "none",
    background: "none",
    color: blackColor,
    textTransform: "none",
    "&:hover,&:focus": {
      textDecoration: "underline",
      boxShadow: "none",
      background: "none",
      color: blackColor
    }
  },
  diaryButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'end',
  },
  diaryImg: {
    width: "100%",
    maxHeight: "60vh",
    objectFit: "contain",
  },
  diaryCancelButton: {
    marginLeft: '8px',
    height: '53px',
  },
  zoomButtons: {
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: '#9f9fa7',
    textAlign: 'center',
    border: 'none',
    margin: 2,
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
    boxShadow: '1px 1px 1px rgba(17, 15, 36, 0.4)',
    cursor: 'pointer',
  },
  // Ajout ou selection d'une entreprise (Pro&HR specific)
  selectCompanyButtonsWrapper: {
    display: "flex",
    alignItems: "center"
  },
  checked: {
    color: primaryColor + "!important"
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px"
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "9px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px"
  },
  selectCompanyButtons: {
    color: blackColor,
    fontSize: 16,
    fontWeight: 400
  },
  selectCompanyButtonsError: {
    color: "#f44336"
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  logoImg: {
    maxHeight: 100,
    maxWidth: 100
  },
  buttonFlat: {
    margin: "5px 0 0",
    padding: 0,
    fontWeight: 400,
    textTransform: "initial"
  },
  // ProfilPage STUDENT (specific)
  formContainer: {
    maxWidth: 960,
    margin: "auto"
  },
  downloadLink: {
    color: blackColor,
    textDecoration: "underline",
    "&:hover, &:focus": {
      color: blackColor,
      textDecoration: "underline"
    }
  },
  socialButtonIcons: {
    fontSize: "18px",
    marginTop: "-2px",
    position: "relative"
  },
  socialButton: {
    minWidth: "auto",
    minHeight: "auto",
    color: "#FFFFFF",
    boxShadow:
      "0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",
    border: "none",
    //borderRadius: "0px",
    position: "relative",
    padding: "10px 30px",
    margin: "0 1px 12.5px 1px",
    fontSize: "12px",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "0",
    willChange: "box-shadow, transform",
    transition:
      "box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    lineHeight: "1.3",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    cursor: "pointer",
    "&:hover": {
      color: "#FFFFFF",
      boxShadow:
        "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
    },
    //full width
    width: "100%",
    paddingLeft: 0,
    paddingRight: 0
  },
  google: {
    backgroundColor: "#dd4b39",
    boxShadow:
      "0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)",
    "&:hover,&:focus": {
      boxShadow:
        "0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"
    }
  },
  checkboxError: {
    "& svg": {
      fill: "red"
    }
  },
  AssociationWrapper: {
    width: "50%",
    "@media (max-width: 991px)": {
      width: "100%"
    },
    "@media (min-width: 992px) and (max-width: 1200px)": {
      width: "80%"
    }
  },
  OfferDetailsTitle: {
    padding: 15,
    margin: 0,
    //...container,
    //lineHeight: "2em",
    fontSize: "28px",
    display: "flex",
    color: "#110f24",
    alignItems: "center",
    fontWeight: 400
  },
  studentGenderIdentity: {
    marginLeft: 0
  },
  primaryColorLink: {
    '&,&:hover,&:focus': {
      color: primaryColor
    },
    wordBreak: "break-word"
  }
};

export default detailsPageStyle;
